import { render, staticRenderFns } from "./AgriculturalStudents.vue?vue&type=template&id=72b08de0&scoped=true"
import script from "./AgriculturalStudents.vue?vue&type=script&lang=js"
export * from "./AgriculturalStudents.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalStudents.vue?vue&type=style&index=0&id=72b08de0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b08de0",
  null
  
)

export default component.exports